export const setResponse = (state, response) => {
    state.response = response;
  };